export
const name: string = "PackToFromRgba";

export
const preproc: string = ``;

export
const declaration: string = `
    // from http://stackoverflow.com/questions/18453302/how-do-you-pack-one-32bit-int-into-4-8bit-ints-in-glsl-webgl
    const vec4 bitEnc = vec4(1.,255.,65025.,16581375.);
    const vec4 bitDec = 1./bitEnc;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    // This function cannot work with 0.0 and 1.0
    vec4 floatToVec4(float v)
    {
        // Fix 0.0 and 1.0
        v = clamp(v, 2e-9, 1.0 - 2e-7);

        vec4 enc = bitEnc * v;
        enc = fract(enc);
        enc -= enc.yzww * vec2(1./255., 0.).xxxy;
        return enc;
    }

    float vec4ToFloat(const vec4 v) {
        return dot(v, bitDec);
    }

    vec4 intToVec4(const float aN) {
      float R, G, B, N;
      R = G = B = 0.0;
      N = aN;

      if (N >= 16777216.0) {
        R = floor(N/16777216.0);
        N -= R*16777216.0;
      }

      if (N >= 65536.0) {
        G = floor(N/65536.0);
        N -= G*65536.0;
      }

      if (N >= 256.0) {
        B = floor(N/256.0);
        N -= B*256.0;
      }

      return vec4(R/255.0, G/255.0, B/255.0, N/255.0);
    }

    vec2 packFloat(const float f) {
        float value = f * 1024.0;
        return vec2(floor(value), fract(value));
    }

    float unpackFloat(const vec2 f) {
        return (f.x + f.y) / 1024.0;
    }
`;
